import axios from "axios";

const API_BASE_URL = process.env.REACT_APP_API_URL;

export const validateAssessments = async (payload, accessToken) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/dev/assessments/bulk/validate`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
};

export const upsertAssessments = async (payload, accessToken) => {
  const response = await axios.post(
    `${API_BASE_URL}/api/dev/assessments/bulk/upsert`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${accessToken}`,
      },
    }
  );

  return response.data;
};